import React, { Component } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Navbar from "./components/global-components/navbar";
import Home from "./components/home";
import HeroFull from "./components/home-full";
import HeroHalf from "./components/home-half";
import BlogFull from "./components/blog-components/blog-full";
import BlogColTwo from "./components/blog-components/blog-2-col";
import BlogColThree from "./components/blog-components/blog-3-col";
import BlogLeftSidebar from "./components/blog-components/blog-left-sidebar";
import BlogRightSidebar from "./components/blog-components/blog-right-sidebar";
import SingleBlog from "./components/blog-components/single";
import SingleLeftSidebar from "./components/blog-components/single-left-sidebar";
import SingleRightSidebar from "./components/blog-components/single-right-sidebar";
import Fof from "./components/global-components/fof";
import ComingSoon from "./components/global-components/coming-soon";
import Footer from "./components/global-components/footer";
import Blogdata from "./data/blog";
import FofData from "./data/fof";
import comingSoonData from "./data/coming-soon";
import ScrollToTop from "./components/global-components/test";
import { HelmetProvider } from "react-helmet-async";

class Root extends Component {
  render() {
    return (
      <HelmetProvider>
        <Router>
          <div>
            <Navbar />
            <ScrollToTop />
            <Switch>
              <Route exact path="/" component={Home} />
              <Route render={() => <Fof data={FofData} />} />
            </Switch>
            <Footer />
          </div>
        </Router>
      </HelmetProvider>
    );
  }
}

export default Root;

ReactDOM.render(<Root />, document.getElementById("sandyapp"));
